class Slider{

    constructor($elt){
        this.$main = $elt;
        this.$slides = this.$main.find('.slider-item');
        this.$slideCurrent = this.$slides.eq(0);
        this.$paginationCurrent = this.$main.find('.current');
        this.$paginationTotal = this.$main.find('.total');
        this.$btnNext = this.$main.find('.chevronNext');
        this.$btnPrev = this.$main.find('.chevronPrev');
        this.currentIndex = 1;
        this.total = this.$slides.length;
        this.initPagination();
    }



    initPagination(){
        var self = this;
        this.$paginationCurrent.html(1);
        this.$paginationTotal.html(this.total);

        this.$btnNext.on('click', function(){
            self.next();
        });
        this.$btnPrev.on('click', function(){
            self.prev();
        });
    }

    next(){
        if(this.currentIndex < this.total){
            this.switchSlide( this.currentIndex + 1);
        } else if (this.currentIndex == this.total){
            this.switchSlide( 1 );
        }
    }

    prev(){
        if(this.currentIndex > 1){
            this.switchSlide( this.currentIndex - 1);
        } else {
            this.switchSlide( this.total);
        }
    }

    switchSlide(num){
        Utils.debug('num : '+num);
        Utils.debug(this.$slides.eq(this.currentIndex));

        TweenMax.fromTo(this.$slideCurrent, 0.3, {
            opacity: 1
        }, {
            opacity: 0,
            display: 'none'
        });

        this.$slideCurrent = this.$slides.eq(num-1);
        this.$slideCurrent.appendTo( this.$slideCurrent.parent() );
        TweenMax.fromTo(this.$slideCurrent, 0.3, {
            opacity: 0,
            display: 'block'
        }, {
            opacity: 1
        });

        this.changeCurrent(num);

    }

    changeCurrent(num){
        this.currentIndex = num;
        this.$paginationCurrent.html(this.currentIndex);
    }

}


module.exports = Slider;